import { render, staticRenderFns } from "./CandidateFiltersChips.vue?vue&type=template&id=d22baeee&lang=pug&"
import script from "./CandidateFiltersChips.vue?vue&type=script&lang=js&"
export * from "./CandidateFiltersChips.vue?vue&type=script&lang=js&"
import style0 from "./CandidateFiltersChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
